import { css } from "lit-element";

//language = CSS
export const style = css`
	editorjs.codex-editor {
		position: relative;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		z-index: 1;
	}
	.codex-editor .hide,
	.codex-editor__redactor--hidden {
		display: none;
	}
	@media (min-width: 651px) {
		.codex-editor--narrow .codex-editor__redactor {
			margin-right: 50px;
		}
	}
	@media (min-width: 651px) {
		.codex-editor--narrow .ce-toolbar__actions {
			right: -5px;
		}
	}
	.codex-editor__loader {
		position: relative;
		height: 30vh;
	}
	.codex-editor__loader:before {
		content: "";
		position: absolute;
		left: 50%;
		top: 50%;
		width: 30px;
		height: 30px;
		margin-top: -15px;
		margin-left: -15px;
		border-radius: 50%;
		border: 2px solid rgba(201, 201, 204, 0.48);
		border-top-color: transparent;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		-webkit-animation: editor-loader-spin 0.8s linear infinite;
		animation: editor-loader-spin 0.8s linear infinite;
		will-change: transform;
	}
	.codex-editor-copyable {
		position: absolute;
		height: 1px;
		width: 1px;
		top: -400%;
		opacity: 0.001;
	}
	.codex-editor-overlay {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 999;
		pointer-events: none;
		overflow: hidden;
	}
	.codex-editor-overlay__container {
		position: relative;
		pointer-events: auto;
		z-index: 0;
	}
	.codex-editor-overlay__rectangle {
		position: absolute;
		pointer-events: none;
		background-color: rgba(46, 170, 220, 0.2);
		border: 1px solid transparent;
	}
	.codex-editor svg {
		fill: currentColor;
		vertical-align: middle;
		max-height: 100%;
	}
	::selection {
		background-color: #a8d6ff;
	}
	.codex-editor--toolbox-opened [contentEditable="true"][data-placeholder]:focus:before {
		opacity: 0 !important;
	}
	@-webkit-keyframes editor-loader-spin {
		0% {
			-webkit-transform: rotate(0deg);
			transform: rotate(0deg);
		}
		to {
			-webkit-transform: rotate(1turn);
			transform: rotate(1turn);
		}
	}
	@keyframes editor-loader-spin {
		0% {
			-webkit-transform: rotate(0deg);
			transform: rotate(0deg);
		}
		to {
			-webkit-transform: rotate(1turn);
			transform: rotate(1turn);
		}
	}
	.ce-toolbar {
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		-webkit-transition: opacity 0.1s ease;
		transition: opacity 0.1s ease;
		will-change: opacity, transform;
		display: none;
	}
	@media (max-width: 650px) {
		.ce-toolbar {
			position: absolute;
			background-color: #fff;
			-webkit-box-shadow: 0 8px 23px -6px rgba(21, 40, 54, 0.31), 22px -14px 34px -18px rgba(33, 48, 73, 0.26);
			box-shadow: 0 8px 23px -6px rgba(21, 40, 54, 0.31), 22px -14px 34px -18px rgba(33, 48, 73, 0.26);
			border-radius: 4px;
			z-index: 2;
		}
	}
	@media (max-width: 650px) and (max-width: 650px) {
		.ce-toolbar {
			-webkit-box-shadow: 0 5px 9px -5px rgba(21, 40, 54, 0.49), 6px 15px 34px -6px rgba(33, 48, 73, 0.54);
			box-shadow: 0 5px 9px -5px rgba(21, 40, 54, 0.49), 6px 15px 34px -6px rgba(33, 48, 73, 0.54);
		}
	}
	@media (max-width: 650px) {
		.ce-toolbar:before {
			content: "";
			width: 15px;
			height: 15px;
			position: absolute;
			top: -7px;
			left: 50%;
			margin-left: -7px;
			-webkit-transform: rotate(-45deg);
			transform: rotate(-45deg);
			background-color: #fff;
			z-index: -1;
		}
		.ce-toolbar {
			padding: 3px;
			margin-top: 5px;
		}
		.ce-toolbar--left-oriented:before {
			left: 15px;
			margin-left: 0;
		}
		.ce-toolbar--right-oriented:before {
			left: auto;
			right: 15px;
			margin-left: 0;
		}
	}
	.ce-toolbar--opened {
		display: block;
	}
	@media (max-width: 650px) {
		.ce-toolbar--opened {
			display: -webkit-box;
			display: -ms-flexbox;
			display: flex;
		}
	}
	.ce-toolbar__content {
		max-width: 650px;
		margin: 0 auto;
		position: relative;
	}
	@media (max-width: 650px) {
		.ce-toolbar__content {
			display: -webkit-box;
			display: -ms-flexbox;
			display: flex;
			-ms-flex-line-pack: center;
			align-content: center;
			margin: 0;
			max-width: calc(100% - 40px);
		}
	}
	.ce-toolbar__plus {
		color: #707684;
		cursor: pointer;
		width: 34px;
		height: 34px;
		display: -webkit-inline-box;
		display: -ms-inline-flexbox;
		display: inline-flex;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		position: absolute;
		left: -34px;
		-ms-flex-negative: 0;
		flex-shrink: 0;
	}
	.ce-toolbar__plus--active,
	.ce-toolbar__plus:hover {
		color: #388ae5;
	}
	.ce-toolbar__plus--active {
		-webkit-animation: bounceIn 0.75s 1;
		animation: bounceIn 0.75s 1;
		-webkit-animation-fill-mode: forwards;
		animation-fill-mode: forwards;
	}
	.ce-toolbar__plus--hidden {
		display: none;
	}
	@media (max-width: 650px) {
		.ce-toolbar__plus {
			display: -webkit-inline-box !important;
			display: -ms-inline-flexbox !important;
			display: inline-flex !important;
			position: static;
			-webkit-transform: none !important;
			transform: none !important;
		}
	}
	.ce-toolbar .ce-toolbox,
	.ce-toolbar__plus {
		top: 50%;
		-webkit-transform: translateY(-50%);
		transform: translateY(-50%);
	}
	.ce-toolbar__actions {
		position: absolute;
		right: 0;
		top: 10px;
		padding-right: 16px;
		opacity: 0;
	}
	@media (max-width: 650px) {
		.ce-toolbar__actions {
			position: static;
			margin-left: auto;
			padding-right: 10px;
			display: -webkit-box;
			display: -ms-flexbox;
			display: flex;
			-webkit-box-align: center;
			-ms-flex-align: center;
			align-items: center;
		}
	}
	.ce-toolbar__actions--opened {
		opacity: 1;
	}
	.ce-toolbar__actions-buttons {
		text-align: right;
	}
	.ce-toolbar__settings-btn {
		display: inline-block;
		width: 24px;
		height: 24px;
		color: #707684;
		cursor: pointer;
	}
	@media (min-width: 651px) {
		.codex-editor--narrow .ce-toolbar__plus {
			left: 5px;
		}
	}
	.ce-toolbox {
		position: absolute;
		visibility: hidden;
		-webkit-transition: opacity 0.1s ease;
		transition: opacity 0.1s ease;
		will-change: opacity;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-orient: horizontal;
		-webkit-box-direction: normal;
		-ms-flex-direction: row;
		flex-direction: row;
	}
	@media (max-width: 650px) {
		.ce-toolbox {
			position: static;
			-webkit-transform: none !important;
			transform: none !important;
			-webkit-box-align: center;
			-ms-flex-align: center;
			align-items: center;
			overflow-x: auto;
		}
	}
	.ce-toolbox--opened {
		opacity: 1;
		visibility: visible;
	}
	.ce-toolbox__button {
		color: #707684;
		cursor: pointer;
		width: 34px;
		height: 34px;
		display: -webkit-inline-box;
		display: -ms-inline-flexbox;
		display: inline-flex;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-ms-flex-negative: 0;
		flex-shrink: 0;
	}
	.ce-toolbox__button--active,
	.ce-toolbox__button:hover {
		color: #388ae5;
	}
	.ce-toolbox__button--active {
		-webkit-animation: bounceIn 0.75s 1;
		animation: bounceIn 0.75s 1;
		-webkit-animation-fill-mode: forwards;
		animation-fill-mode: forwards;
	}
	.ce-toolbox__tooltip {
		position: absolute;
		top: 25px;
		padding: 6px 10px;
		border-radius: 5px;
		opacity: 0;
		background: #eff2f5;
		-webkit-box-shadow: 0 10px 12px -9px rgba(26, 39, 54, 0.32), 0 3px 2px -2px rgba(33, 48, 73, 0.05);
		box-shadow: 0 10px 12px -9px rgba(26, 39, 54, 0.32), 0 3px 2px -2px rgba(33, 48, 73, 0.05);
		color: #5c6174;
		font-size: 12px;
		text-align: center;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		pointer-events: none;
		-webkit-transition: opacity 0.15s ease-in, left 0.1s linear;
		transition: opacity 0.15s ease-in, left 0.1s linear;
		will-change: opacity, left;
		letter-spacing: 0.02em;
		line-height: 1em;
	}
	@media (max-width: 650px) {
		.ce-toolbox__tooltip {
			display: none;
		}
	}
	.ce-toolbox__tooltip-shortcut {
		color: rgba(100, 105, 122, 0.6);
		word-spacing: -2px;
		margin-top: 5px;
	}
	.ce-toolbox__tooltip--shown {
		opacity: 1;
		-webkit-transition-delay: 0.1s, 0s;
		transition-delay: 0.1s, 0s;
	}
	.ce-toolbox__tooltip:before {
		content: "";
		width: 10px;
		height: 10px;
		position: absolute;
		top: -5px;
		left: 50%;
		margin-left: -5px;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		background-color: #eff2f5;
		z-index: -1;
	}
	@media (min-width: 651px) {
		.codex-editor--narrow .ce-toolbox {
			background: #fff;
			z-index: 2;
		}
	}
	.ce-inline-toolbar {
		position: absolute;
		background-color: #fff;
		-webkit-box-shadow: 0 8px 23px -6px rgba(21, 40, 54, 0.31), 22px -14px 34px -18px rgba(33, 48, 73, 0.26);
		box-shadow: 0 8px 23px -6px rgba(21, 40, 54, 0.31), 22px -14px 34px -18px rgba(33, 48, 73, 0.26);
		border-radius: 4px;
		z-index: 2;
	}
	@media (max-width: 650px) {
		.ce-inline-toolbar {
			-webkit-box-shadow: 0 5px 9px -5px rgba(21, 40, 54, 0.49), 6px 15px 34px -6px rgba(33, 48, 73, 0.54);
			box-shadow: 0 5px 9px -5px rgba(21, 40, 54, 0.49), 6px 15px 34px -6px rgba(33, 48, 73, 0.54);
		}
	}
	.ce-inline-toolbar:before {
		content: "";
		width: 15px;
		height: 15px;
		position: absolute;
		top: -7px;
		left: 50%;
		margin-left: -7px;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		background-color: #fff;
		z-index: -1;
	}
	.ce-inline-toolbar {
		padding: 3px;
		-webkit-transform: translateX(-50%) translateY(8px) scale(0.9);
		transform: translateX(-50%) translateY(8px) scale(0.9);
		-webkit-box-shadow: 0 6px 12px -6px rgba(131, 147, 173, 0.46), 5px -12px 34px -13px rgba(97, 105, 134, 0.6),
			0 26px 52px 3px rgba(147, 165, 186, 0.24);
		box-shadow: 0 6px 12px -6px rgba(131, 147, 173, 0.46), 5px -12px 34px -13px rgba(97, 105, 134, 0.6),
			0 26px 52px 3px rgba(147, 165, 186, 0.24);
		opacity: 0;
		visibility: hidden;
		-webkit-transition: opacity 0.25s ease, -webkit-transform 0.15s ease;
		transition: opacity 0.25s ease, -webkit-transform 0.15s ease;
		transition: transform 0.15s ease, opacity 0.25s ease;
		transition: transform 0.15s ease, opacity 0.25s ease, -webkit-transform 0.15s ease;
		will-change: transform, opacity;
	}
	.ce-inline-toolbar--left-oriented:before {
		left: 15px;
		margin-left: 0;
	}
	.ce-inline-toolbar--right-oriented:before {
		left: auto;
		right: 15px;
		margin-left: 0;
	}
	.ce-inline-toolbar--showed {
		opacity: 1;
		visibility: visible;
		-webkit-transform: translateX(-50%);
		transform: translateX(-50%);
	}
	.ce-inline-toolbar--left-oriented {
		-webkit-transform: translateX(-23px) translateY(8px) scale(0.9);
		transform: translateX(-23px) translateY(8px) scale(0.9);
	}
	.ce-inline-toolbar--left-oriented.ce-inline-toolbar--showed {
		-webkit-transform: translateX(-23px);
		transform: translateX(-23px);
	}
	.ce-inline-toolbar--right-oriented {
		-webkit-transform: translateX(-100%) translateY(8px) scale(0.9);
		transform: translateX(-100%) translateY(8px) scale(0.9);
		margin-left: 23px;
	}
	.ce-inline-toolbar--right-oriented.ce-inline-toolbar--showed {
		-webkit-transform: translateX(-100%);
		transform: translateX(-100%);
	}
	.ce-inline-toolbar [hidden] {
		display: none !important;
	}
	.ce-inline-toolbar__buttons {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
	}
	.ce-inline-tool {
		display: -webkit-inline-box;
		display: -ms-inline-flexbox;
		display: inline-flex;
		width: 34px;
		height: 34px;
		line-height: 34px;
		padding: 0 !important;
		text-align: center;
		border-radius: 3px;
		cursor: pointer;
		border: 0;
		outline: none;
		background-color: transparent;
		vertical-align: bottom;
		color: #707684;
	}
	.ce-inline-tool:hover {
		background-color: #eff2f5;
	}
	.ce-inline-tool {
		line-height: normal;
	}
	.ce-inline-tool .icon,
	.ce-inline-tool > svg {
		margin: auto;
	}
	.ce-inline-tool--active {
		color: #388ae5;
	}
	.ce-inline-tool--focused {
		-webkit-box-shadow: inset 0 0 0 1px rgba(7, 161, 227, 0.08);
		box-shadow: inset 0 0 0 1px rgba(7, 161, 227, 0.08);
		background: rgba(34, 186, 255, 0.08) !important;
	}
	.ce-inline-tool--focused-animated {
		-webkit-animation-name: buttonClicked;
		animation-name: buttonClicked;
		-webkit-animation-duration: 0.25s;
		animation-duration: 0.25s;
	}
	.ce-inline-tool:not(:last-of-type) {
		margin-right: 2px;
	}
	.ce-inline-tool--last {
		margin-right: 0 !important;
	}
	.ce-inline-tool--link .icon--unlink,
	.ce-inline-tool--unlink .icon--link {
		display: none;
	}
	.ce-inline-tool--unlink .icon--unlink {
		display: inline-block;
	}
	.ce-inline-tool-input {
		background-color: #eff2f5;
		outline: none;
		border: 0;
		border-radius: 3px;
		margin: 3px 0 0;
		font-size: 13px;
		padding: 8px;
		width: 100%;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		display: none;
	}
	.ce-inline-tool-input::-webkit-input-placeholder {
		color: #707684;
	}
	.ce-inline-tool-input:-ms-input-placeholder {
		color: #707684;
	}
	.ce-inline-tool-input::-ms-input-placeholder {
		color: #707684;
	}
	.ce-inline-tool-input::placeholder {
		color: #707684;
	}
	.ce-inline-tool-input--showed {
		display: block;
	}
	.ce-conversion-toolbar {
		position: absolute;
		background-color: #fff;
		-webkit-box-shadow: 0 8px 23px -6px rgba(21, 40, 54, 0.31), 22px -14px 34px -18px rgba(33, 48, 73, 0.26);
		box-shadow: 0 8px 23px -6px rgba(21, 40, 54, 0.31), 22px -14px 34px -18px rgba(33, 48, 73, 0.26);
		border-radius: 4px;
		z-index: 2;
	}
	@media (max-width: 650px) {
		.ce-conversion-toolbar {
			-webkit-box-shadow: 0 5px 9px -5px rgba(21, 40, 54, 0.49), 6px 15px 34px -6px rgba(33, 48, 73, 0.54);
			box-shadow: 0 5px 9px -5px rgba(21, 40, 54, 0.49), 6px 15px 34px -6px rgba(33, 48, 73, 0.54);
		}
	}
	.ce-conversion-toolbar:before {
		content: "";
		width: 15px;
		height: 15px;
		position: absolute;
		top: -7px;
		left: 50%;
		margin-left: -7px;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		background-color: #fff;
		z-index: -1;
	}
	.ce-conversion-toolbar {
		padding: 3px;
		-webkit-box-shadow: 0 6px 12px -6px rgba(131, 147, 173, 0.46), 5px -12px 34px -13px rgba(97, 105, 134, 0.6),
			0 26px 52px 3px rgba(147, 165, 186, 0.24);
		box-shadow: 0 6px 12px -6px rgba(131, 147, 173, 0.46), 5px -12px 34px -13px rgba(97, 105, 134, 0.6),
			0 26px 52px 3px rgba(147, 165, 186, 0.24);
		opacity: 0;
		visibility: hidden;
		will-change: transform, opacity;
		-webkit-transition: opacity 0.25s ease, -webkit-transform 0.15s ease;
		transition: opacity 0.25s ease, -webkit-transform 0.15s ease;
		transition: transform 0.15s ease, opacity 0.25s ease;
		transition: transform 0.15s ease, opacity 0.25s ease, -webkit-transform 0.15s ease;
		-webkit-transform: translateY(8px) scale(0.9);
		transform: translateY(8px) scale(0.9);
	}
	.ce-conversion-toolbar--left-oriented:before {
		left: 15px;
		margin-left: 0;
	}
	.ce-conversion-toolbar--right-oriented:before {
		left: auto;
		right: 15px;
		margin-left: 0;
	}
	.ce-conversion-toolbar:before {
		left: 20px;
	}
	.ce-conversion-toolbar--showed {
		opacity: 1;
		visibility: visible;
		-webkit-transform: none;
		transform: none;
	}
	.ce-conversion-toolbar [hidden] {
		display: none !important;
	}
	.ce-conversion-toolbar__buttons {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
	}
	.ce-conversion-tool {
		display: -webkit-inline-box;
		display: -ms-inline-flexbox;
		display: inline-flex;
		width: 34px;
		height: 34px;
		line-height: 34px;
		padding: 0 !important;
		text-align: center;
		border-radius: 3px;
		cursor: pointer;
		border: 0;
		outline: none;
		background-color: transparent;
		vertical-align: bottom;
		color: #707684;
	}
	.ce-conversion-tool:hover {
		background-color: #eff2f5;
	}
	.ce-conversion-tool {
		line-height: normal;
	}
	.ce-conversion-tool .icon,
	.ce-conversion-tool > svg {
		margin: auto;
	}
	.ce-conversion-tool--active {
		color: #388ae5;
	}
	.ce-conversion-tool--focused {
		-webkit-box-shadow: inset 0 0 0 1px rgba(7, 161, 227, 0.08);
		box-shadow: inset 0 0 0 1px rgba(7, 161, 227, 0.08);
		background: rgba(34, 186, 255, 0.08) !important;
	}
	.ce-conversion-tool--focused-animated {
		-webkit-animation-name: buttonClicked;
		animation-name: buttonClicked;
		-webkit-animation-duration: 0.25s;
		animation-duration: 0.25s;
	}
	.ce-conversion-tool:not(:last-of-type) {
		margin-right: 2px;
	}
	.ce-conversion-tool--last {
		margin-right: 0 !important;
	}
	.ce-conversion-tool--active,
	.ce-conversion-tool:hover {
		color: #388ae5 !important;
	}
	.ce-conversion-tool--active {
		-webkit-animation: bounceIn 0.75s 1;
		animation: bounceIn 0.75s 1;
		-webkit-animation-fill-mode: forwards;
		animation-fill-mode: forwards;
	}
	.ce-settings {
		position: absolute;
		background-color: #fff;
		-webkit-box-shadow: 0 8px 23px -6px rgba(21, 40, 54, 0.31), 22px -14px 34px -18px rgba(33, 48, 73, 0.26);
		box-shadow: 0 8px 23px -6px rgba(21, 40, 54, 0.31), 22px -14px 34px -18px rgba(33, 48, 73, 0.26);
		border-radius: 4px;
		z-index: 2;
	}
	@media (max-width: 650px) {
		.ce-settings {
			-webkit-box-shadow: 0 5px 9px -5px rgba(21, 40, 54, 0.49), 6px 15px 34px -6px rgba(33, 48, 73, 0.54);
			box-shadow: 0 5px 9px -5px rgba(21, 40, 54, 0.49), 6px 15px 34px -6px rgba(33, 48, 73, 0.54);
		}
	}
	.ce-settings:before {
		content: "";
		width: 15px;
		height: 15px;
		position: absolute;
		top: -7px;
		left: 50%;
		margin-left: -7px;
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		background-color: #fff;
		z-index: -1;
	}
	.ce-settings {
		right: 5px;
		top: 35px;
		min-width: 114px;
	}
	.ce-settings--left-oriented:before {
		left: 15px;
		margin-left: 0;
	}
	.ce-settings--right-oriented:before {
		left: auto;
		right: 15px;
		margin-left: 0;
	}
	@media (max-width: 650px) {
		.ce-settings {
			bottom: 50px;
			top: auto;
		}
	}
	.ce-settings:before {
		left: auto;
		right: 12px;
	}
	@media (max-width: 650px) {
		.ce-settings:before {
			bottom: -5px;
			top: auto;
		}
	}
	.ce-settings {
		display: none;
	}
	.ce-settings--opened {
		display: block;
		-webkit-animation-duration: 0.1s;
		animation-duration: 0.1s;
		-webkit-animation-name: panelShowing;
		animation-name: panelShowing;
	}
	.ce-settings__plugin-zone:not(:empty) {
		padding: 3px 3px 0;
	}
	.ce-settings__default-zone:not(:empty) {
		padding: 3px;
	}
	.ce-settings__button {
		display: -webkit-inline-box;
		display: -ms-inline-flexbox;
		display: inline-flex;
		width: 34px;
		height: 34px;
		line-height: 34px;
		padding: 0 !important;
		text-align: center;
		border-radius: 3px;
		cursor: pointer;
		border: 0;
		outline: none;
		background-color: transparent;
		vertical-align: bottom;
		color: #707684;
	}
	.ce-settings__button:hover {
		background-color: #eff2f5;
	}
	.ce-settings__button .icon,
	.ce-settings__button > svg {
		margin: auto;
	}
	.ce-settings__button--active {
		color: #388ae5;
	}
	.ce-settings__button--focused {
		-webkit-box-shadow: inset 0 0 0 1px rgba(7, 161, 227, 0.08);
		box-shadow: inset 0 0 0 1px rgba(7, 161, 227, 0.08);
		background: rgba(34, 186, 255, 0.08) !important;
	}
	.ce-settings__button--focused-animated {
		-webkit-animation-name: buttonClicked;
		animation-name: buttonClicked;
		-webkit-animation-duration: 0.25s;
		animation-duration: 0.25s;
	}
	.ce-settings__button:not(:nth-child(3n + 3)) {
		margin-right: 3px;
	}
	.ce-settings__button:nth-child(n + 4) {
		margin-top: 3px;
	}
	.ce-settings__button {
		line-height: 32px;
	}
	.ce-settings__button--disabled {
		cursor: not-allowed !important;
		opacity: 0.3;
	}
	.ce-settings__button--selected {
		color: #388ae5;
	}
	.ce-settings__button--delete {
		-webkit-transition: background-color 0.3s ease;
		transition: background-color 0.3s ease;
		will-change: background-color;
	}
	.ce-settings__button--delete .icon {
		-webkit-transition: -webkit-transform 0.2s ease-out;
		transition: -webkit-transform 0.2s ease-out;
		transition: transform 0.2s ease-out;
		transition: transform 0.2s ease-out, -webkit-transform 0.2s ease-out;
		will-change: transform;
	}
	.ce-settings__button--confirm {
		background-color: #e24a4a !important;
		color: #fff;
	}
	.ce-settings__button--confirm:hover {
		background-color: #d54a4a !important;
	}
	.ce-settings__button--confirm .icon {
		-webkit-transform: rotate(90deg);
		transform: rotate(90deg);
	}
	.ce-block:first-of-type {
		margin-top: 0;
	}
	.ce-block--focused {
		background-image: linear-gradient(17deg, rgba(243, 248, 255, 0.03) 63.45%, rgba(207, 214, 229, 0.27) 98%);
		border-radius: 3px;
	}
	@media (max-width: 650px) {
		.ce-block--focused {
			background-image: none;
			background-color: rgba(200, 199, 219, 0.17);
			margin: 0 -10px;
			padding: 0 10px;
		}
	}
	.ce-block--selected .ce-block__content {
		background: #a8d6ff;
		-webkit-box-shadow: 0 31px 23px -22px #afdcff;
		box-shadow: 0 31px 23px -22px #afdcff;
		-webkit-animation: selectionBounce 0.2s 1;
		animation: selectionBounce 0.2s 1;
		-webkit-animation-fill-mode: forwards;
		animation-fill-mode: forwards;
	}
	.ce-block--selected .ce-block__content [contenteditable] {
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}
	.ce-block--selected .ce-block__content .ce-stub,
	.ce-block--selected .ce-block__content img {
		opacity: 0.55;
	}
	.ce-block--stretched .ce-block__content {
		max-width: none;
	}
	.ce-block__content {
		position: relative;
		max-width: 650px;
		margin: 0 auto;
	}
	.ce-block--drop-target .ce-block__content:before {
		content: "";
		position: absolute;
		top: 100%;
		left: -20px;
		margin-top: -1px;
		height: 8px;
		width: 8px;
		border: solid #388ae5;
		border-width: 1px 1px 0 0;
		-webkit-transform-origin: right;
		transform-origin: right;
		-webkit-transform: rotate(45deg);
		transform: rotate(45deg);
	}
	.ce-block--drop-target .ce-block__content:after {
		content: "";
		position: absolute;
		top: 100%;
		height: 1px;
		width: 100%;
		color: #388ae5;
		background: repeating-linear-gradient(90deg, #388ae5, #388ae5 1px, #fff 0, #fff 6px);
	}
	.ce-block a {
		cursor: pointer;
		text-decoration: underline;
	}
	.ce-block b {
		font-weight: 700;
	}
	.ce-block i {
		font-style: italic;
	}
	@media (min-width: 651px) {
		.codex-editor--narrow .ce-block--focused {
			margin-right: -50px;
			padding-right: 50px;
		}
	}
	.wobble {
		-webkit-animation-name: wobble;
		animation-name: wobble;
		-webkit-animation-duration: 0.4s;
		animation-duration: 0.4s;
	}
	@-webkit-keyframes wobble {
		0% {
			-webkit-transform: translateZ(0);
			transform: translateZ(0);
		}
		15% {
			-webkit-transform: translate3d(-5%, 0, 0) rotate(-5deg);
			transform: translate3d(-5%, 0, 0) rotate(-5deg);
		}
		30% {
			-webkit-transform: translate3d(2%, 0, 0) rotate(3deg);
			transform: translate3d(2%, 0, 0) rotate(3deg);
		}
		45% {
			-webkit-transform: translate3d(-3%, 0, 0) rotate(-3deg);
			transform: translate3d(-3%, 0, 0) rotate(-3deg);
		}
		60% {
			-webkit-transform: translate3d(2%, 0, 0) rotate(2deg);
			transform: translate3d(2%, 0, 0) rotate(2deg);
		}
		75% {
			-webkit-transform: translate3d(-1%, 0, 0) rotate(-1deg);
			transform: translate3d(-1%, 0, 0) rotate(-1deg);
		}
		to {
			-webkit-transform: translateZ(0);
			transform: translateZ(0);
		}
	}
	@keyframes wobble {
		0% {
			-webkit-transform: translateZ(0);
			transform: translateZ(0);
		}
		15% {
			-webkit-transform: translate3d(-5%, 0, 0) rotate(-5deg);
			transform: translate3d(-5%, 0, 0) rotate(-5deg);
		}
		30% {
			-webkit-transform: translate3d(2%, 0, 0) rotate(3deg);
			transform: translate3d(2%, 0, 0) rotate(3deg);
		}
		45% {
			-webkit-transform: translate3d(-3%, 0, 0) rotate(-3deg);
			transform: translate3d(-3%, 0, 0) rotate(-3deg);
		}
		60% {
			-webkit-transform: translate3d(2%, 0, 0) rotate(2deg);
			transform: translate3d(2%, 0, 0) rotate(2deg);
		}
		75% {
			-webkit-transform: translate3d(-1%, 0, 0) rotate(-1deg);
			transform: translate3d(-1%, 0, 0) rotate(-1deg);
		}
		to {
			-webkit-transform: translateZ(0);
			transform: translateZ(0);
		}
	}
	@-webkit-keyframes bounceIn {
		0%,
		20%,
		40%,
		60%,
		80%,
		to {
			-webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
			animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
		}
		0% {
			-webkit-transform: scale3d(0.9, 0.9, 0.9);
			transform: scale3d(0.9, 0.9, 0.9);
		}
		20% {
			-webkit-transform: scale3d(1.03, 1.03, 1.03);
			transform: scale3d(1.03, 1.03, 1.03);
		}
		60% {
			-webkit-transform: scaleX(1);
			transform: scaleX(1);
		}
	}
	@keyframes bounceIn {
		0%,
		20%,
		40%,
		60%,
		80%,
		to {
			-webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
			animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
		}
		0% {
			-webkit-transform: scale3d(0.9, 0.9, 0.9);
			transform: scale3d(0.9, 0.9, 0.9);
		}
		20% {
			-webkit-transform: scale3d(1.03, 1.03, 1.03);
			transform: scale3d(1.03, 1.03, 1.03);
		}
		60% {
			-webkit-transform: scaleX(1);
			transform: scaleX(1);
		}
	}
	@-webkit-keyframes selectionBounce {
		0%,
		20%,
		40%,
		60%,
		80%,
		to {
			-webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
			animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
		}
		50% {
			-webkit-transform: scale3d(1.01, 1.01, 1.01);
			transform: scale3d(1.01, 1.01, 1.01);
		}
		70% {
			-webkit-transform: scaleX(1);
			transform: scaleX(1);
		}
	}
	@keyframes selectionBounce {
		0%,
		20%,
		40%,
		60%,
		80%,
		to {
			-webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
			animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
		}
		50% {
			-webkit-transform: scale3d(1.01, 1.01, 1.01);
			transform: scale3d(1.01, 1.01, 1.01);
		}
		70% {
			-webkit-transform: scaleX(1);
			transform: scaleX(1);
		}
	}
	@-webkit-keyframes buttonClicked {
		0%,
		20%,
		40%,
		60%,
		80%,
		to {
			-webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
			animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
		}
		0% {
			-webkit-transform: scale3d(0.95, 0.95, 0.95);
			transform: scale3d(0.95, 0.95, 0.95);
		}
		60% {
			-webkit-transform: scale3d(1.02, 1.02, 1.02);
			transform: scale3d(1.02, 1.02, 1.02);
		}
		80% {
			-webkit-transform: scaleX(1);
			transform: scaleX(1);
		}
	}
	@keyframes buttonClicked {
		0%,
		20%,
		40%,
		60%,
		80%,
		to {
			-webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
			animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
		}
		0% {
			-webkit-transform: scale3d(0.95, 0.95, 0.95);
			transform: scale3d(0.95, 0.95, 0.95);
		}
		60% {
			-webkit-transform: scale3d(1.02, 1.02, 1.02);
			transform: scale3d(1.02, 1.02, 1.02);
		}
		80% {
			-webkit-transform: scaleX(1);
			transform: scaleX(1);
		}
	}
	@-webkit-keyframes panelShowing {
		0% {
			opacity: 0;
			-webkit-transform: translateY(-8px) scale(0.9);
			transform: translateY(-8px) scale(0.9);
		}
		70% {
			opacity: 1;
			-webkit-transform: translateY(2px);
			transform: translateY(2px);
		}
		to {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
	}
	@keyframes panelShowing {
		0% {
			opacity: 0;
			-webkit-transform: translateY(-8px) scale(0.9);
			transform: translateY(-8px) scale(0.9);
		}
		70% {
			opacity: 1;
			-webkit-transform: translateY(2px);
			transform: translateY(2px);
		}
		to {
			-webkit-transform: translateY(0);
			transform: translateY(0);
		}
	}
	.cdx-block {
		padding: 0.7em 0;
	}
	.cdx-input {
		border: 1px solid rgba(201, 201, 204, 0.48);
		-webkit-box-shadow: inset 0 1px 2px 0 rgba(35, 44, 72, 0.06);
		box-shadow: inset 0 1px 2px 0 rgba(35, 44, 72, 0.06);
		border-radius: 3px;
		padding: 10px 12px;
		outline: none;
		width: 100%;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
	}
	.cdx-settings-button {
		display: -webkit-inline-box;
		display: -ms-inline-flexbox;
		display: inline-flex;
		width: 34px;
		height: 34px;
		line-height: 34px;
		padding: 0 !important;
		text-align: center;
		border-radius: 3px;
		cursor: pointer;
		border: 0;
		outline: none;
		background-color: transparent;
		vertical-align: bottom;
		color: #707684;
	}
	.cdx-settings-button:hover {
		background-color: #eff2f5;
	}
	.cdx-settings-button .icon,
	.cdx-settings-button > svg {
		margin: auto;
	}
	.cdx-settings-button--focused {
		-webkit-box-shadow: inset 0 0 0 1px rgba(7, 161, 227, 0.08);
		box-shadow: inset 0 0 0 1px rgba(7, 161, 227, 0.08);
		background: rgba(34, 186, 255, 0.08) !important;
	}
	.cdx-settings-button--focused-animated {
		-webkit-animation-name: buttonClicked;
		animation-name: buttonClicked;
		-webkit-animation-duration: 0.25s;
		animation-duration: 0.25s;
	}
	.cdx-settings-button:not(:nth-child(3n + 3)) {
		margin-right: 3px;
	}
	.cdx-settings-button:nth-child(n + 4) {
		margin-top: 3px;
	}
	.cdx-settings-button--active {
		color: #388ae5;
	}
	.cdx-loader {
		position: relative;
		border: 1px solid rgba(201, 201, 204, 0.48);
	}
	.cdx-loader:before {
		content: "";
		position: absolute;
		left: 50%;
		top: 50%;
		width: 18px;
		height: 18px;
		margin: -11px 0 0 -11px;
		border: 2px solid rgba(201, 201, 204, 0.48);
		border-left-color: #388ae5;
		border-radius: 50%;
		-webkit-animation: cdxRotation 1.2s linear infinite;
		animation: cdxRotation 1.2s linear infinite;
	}
	@-webkit-keyframes cdxRotation {
		0% {
			-webkit-transform: rotate(0deg);
			transform: rotate(0deg);
		}
		to {
			-webkit-transform: rotate(1turn);
			transform: rotate(1turn);
		}
	}
	@keyframes cdxRotation {
		0% {
			-webkit-transform: rotate(0deg);
			transform: rotate(0deg);
		}
		to {
			-webkit-transform: rotate(1turn);
			transform: rotate(1turn);
		}
	}
	.cdx-button {
		padding: 13px;
		border-radius: 3px;
		border: 1px solid rgba(201, 201, 204, 0.48);
		font-size: 14.9px;
		background: #fff;
		-webkit-box-shadow: 0 2px 2px 0 rgba(18, 30, 57, 0.04);
		box-shadow: 0 2px 2px 0 rgba(18, 30, 57, 0.04);
		color: #707684;
		text-align: center;
		cursor: pointer;
	}
	.cdx-button:hover {
		background: #fbfcfe;
		-webkit-box-shadow: 0 1px 3px 0 rgba(18, 30, 57, 0.08);
		box-shadow: 0 1px 3px 0 rgba(18, 30, 57, 0.08);
	}
	.cdx-button svg {
		height: 20px;
		margin-right: 0.2em;
		margin-top: -2px;
	}
	.ce-stub {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
		width: 100%;
		padding: 3.5em 0;
		margin: 17px 0;
		border-radius: 3px;
		background: #fcf7f7;
		color: #b46262;
	}
	.ce-stub__info {
		margin-left: 20px;
	}
	.ce-stub__title {
		margin-bottom: 3px;
		font-weight: 600;
		font-size: 18px;
		text-transform: capitalize;
	}
	.ce-stub__subtitle {
		font-size: 16px;
	}
`;
